import { Button, ButtonGroup, Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import React, { useState } from 'react';
import PageHeading from '../../Components/PageHeading';
import PageLoader from '../../Components/PageLoader';
import IssuesFilter from './Components/IssuesFilter';
import KeyIssues from './Components/KeyIssues';
import CampaignIssues from './Components/CampaignIssues';
import SelectCampaign from '../../Components/SelectCampaign';
import CampaignEmptyState from '../../Components/CampaignEmptyState';


export default function IssuesRaised() {
	const [loading, setLoading] = useState(false);
	// const [filterQuery, setFilterQuery] = useState(null); -> this will we use in fucture for combined filter including campaigns.. array right now only need campaign
	const [campaignId, setCampaignId] = useState(null);
	const [viewType, setViewType] = useState(0);   // for button group

	const [value, setValue] = React.useState(0);
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const handleSelectCampaign = (i, option) => {
		console.log('Selected Campaign iddd:-------', option?.item?._id);
		setCampaignId(option?.item?._id);
	};

	const tabs = [
	{
		code: 'Key Issues',
		Component: KeyIssues,
		props: { campaignId , viewType },

	},
	{
		code: 'Campaign View',
		Component: CampaignIssues,
	},
];

	return (
		<Stack sx={{ padding: 2 }}>
			<PageHeading title="Issues raised" subTitle="Track, manage and resolve employees raised issues" />
			<Stack mt={2} gap={1}>
				<Stack direction="row" alignItems="center" justifyContent="space-between">
				<SelectCampaign handleSelectCampaign={handleSelectCampaign} width={'488px'} />

				{campaignId && (
									<ButtonGroup>
										<Button variant={viewType === 0 ? 'contained' : 'outlined'} color="info" onClick={() => setViewType(0)}>
											Detailed
										</Button>
										<Button variant={viewType === 1 ? 'contained' : 'outlined'} color="info" onClick={() => setViewType(1)}>
											Summary
										</Button>
									</ButtonGroup>
								)}
				</Stack>				

				{/* <Stack direction="row" alignItems="center" justifyContent="space-between">
					<ToggleButtonGroup size="small" color="primary" value={value} exclusive onChange={handleChange}>
						{tabs?.map((tab, index) => (
							<ToggleButton
								key={index}
								sx={{ textTransform: 'none', px: 2, borderRadius: '8px', alignItems: 'center' }}
								value={index}
							>
								<Typography variant="subtitle2" fontSize={13} fontWeight={500}>
									{tab?.code}
								</Typography>
							</ToggleButton>
						))}
					</ToggleButtonGroup>
					<IssuesFilter setFilterQuery={setFilterQuery} />
				</Stack> */}

				{!campaignId && <CampaignEmptyState text="Select a campaign to view campaign insights." />}
				

				{tabs.map(({ Component, props }, index) => index == value && <Component key={index} {...props} />)}
			</Stack>
			{loading && <PageLoader />}
		</Stack>
	);
}
